import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

const AboutStoragePower: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    fill="none"
    viewBox="0 0 80 80"
  >
    <path
      stroke={colors['--green-500']}
      strokeWidth="3"
      d="M54.625 39.625h-1.5V44.5h-.25v-4.875H48v-.25h4.875V34.5h.25v4.875H58v.25h-3.375zM62.75 25H61v-3.375a3.125 3.125 0 00-3.125-3.125h-9.75A3.125 3.125 0 0045 21.625V25H35v-3.375a3.125 3.125 0 00-3.125-3.125h-9.75A3.125 3.125 0 0019 21.625V25h-1.75a4.75 4.75 0 00-4.75 4.75v26a4.75 4.75 0 004.75 4.75h45.5a4.75 4.75 0 004.75-4.75v-26A4.75 4.75 0 0062.75 25zM32 39.375v.25H22v-.25h10z"
    />
    <path stroke={colors['--green-500']} strokeWidth="3" d="M1.5 1.5H78.5V78.5H1.5z" />
  </svg>
);

export default AboutStoragePower;
